<template>
  <span
    :name="schema.model"
    v-bind="schema.attributesLabel"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-block', getSelectedDEV && 'dev-selected-component', schema.attributesLabel.class]"
  >
    <div :class="['d-flex']">
      <v-icon
        v-if="schema.appendIcon && !schema.appendIcon.tooltip"
        :class="[schema.appendIcon.right ? 'ml-1 order-2' : 'mr-1']"
        v-bind="schema.appendIcon.attributesIcon"
        :disabled="schema.readonly"
      >
        {{ schema.appendIcon.icon }}
      </v-icon>

      <template v-if="schema.appendIcon && schema.appendIcon.tooltip">
        <v-tooltip
          :open-on-hover="('hasAction' in schema.appendIcon) && schema.appendIcon.hasAction"
          v-bind="schema.appendIcon.tooltip.attributesTooltip ? schema.appendIcon.tooltip.attributesTooltip : attributesTooltipDefault"
          :color="schema.appendIcon.tooltip.tooltipColorClass"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="('hasAction' in schema.appendIcon) && schema.appendIcon.hasAction"
              @click="on && execute(schema.appendIcon.actions.items[0])"
              :data-has-tooltip="schema.appendIcon.tooltip.text ? 'true' : 'false'"
              :data-tooltip="schema.appendIcon.tooltip.text"
              v-on="on"
              :class="[schema.appendIcon.right ? 'ml-1 order-2' : 'mr-1']"
              v-bind="[schema.appendIcon.attributesIcon, attrs]"
              :disabled="schema.readonly"
              >{{ schema.appendIcon.icon }}</v-icon
            >
            <v-icon
              v-else
              @click="on.click"
              :data-has-tooltip="schema.appendIcon.tooltip.text ? 'true' : 'false'"
              :data-tooltip="schema.appendIcon.tooltip.text"
              v-on="on"
              :class="[schema.appendIcon.right ? 'ml-1 order-2' : 'mr-1']"
              v-bind="[schema.appendIcon.attributesIcon, attrs]"
              :disabled="schema.readonly"
              >{{ schema.appendIcon.icon }}</v-icon
            >
          </template>
          <span>{{ schema.appendIcon.tooltip.text }}</span>
        </v-tooltip>
      </template>

      {{ value ? value : schema.text }}
    </div>

    <span v-if="schema.textHint" :class="['d-flex textHint', schema.textHint.class]">{{ schema.textHint.text }}</span>
  </span>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import appendIconAction from '@/mixins/appendicon-action-mixins';

export default {
  mixins: [abstractField, devComponentMixin, appendIconAction]
};
</script>

<style lang="scss" scoped>
.textHint {
  font-size: 14px;
  width: 100%;
}
</style>
